<template>
  <Teleport to="body">
    <div class="login-modal-overlay" @click.self="$emit('close')">
      <div v-if="!showSignupContent" class="login-modal-content rounded overflow-hidden">
        <div class="card bg-dark text-white border-0">
          <div class="card-body p-4">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <h3 class="card-title m-0 text-warning">Logowanie</h3>
              <button type="button" class="btn-close btn-close-white" @click="$emit('close')"></button>
            </div>
            <form @submit.prevent="handleLogin" v-if="!authStore.user">
              <div class="mb-3">
                <label for="email" class="form-label"><font-awesome-icon icon="fa-at"/> Email</label>
                <input
                    type="email"
                    class="form-control bg-dark text-white border-secondary"
                    id="email"
                    v-model="email"
                    required
                    placeholder="twoj@email.pl"
                >
              </div>
              <div class="mb-3">
                <label for="password" class="form-label"><font-awesome-icon icon="fa-key"/> Hasło</label>
                <input
                    type="password"
                    class="form-control bg-dark text-white border-secondary"
                    id="password"
                    v-model="password"
                    required
                    placeholder="hasło"
                >
              </div>
              <div v-if="errorMessage" class="alert alert-danger py-2">
                {{ errorMessage }}
              </div>
              <div class="d-grid mt-4">
                <button
                    type="submit"
                    class="btn btn-warning fw-bold"
                    :disabled="isLoading"
                >
                  <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
                  Zaloguj się
                </button>
              </div>
              <div v-if="!authStore.user" class="text-center mt-3">
                <a  href="#" class="nav-link" @click.prevent="showSignupContent=true">
                  <font-awesome-icon icon="fa-regular fa-circle-user" /> Zarejestruj się
                </a>
              </div>
            </form>
            <div v-else class="alert alert-success py-2">
              Poprawnie zalogowano!
            </div>
          </div>
        </div>
      </div>
      <div v-else class="login-modal-content rounded overflow-hidden">
        <SignupPage @close="showSignupContent = false" />
      </div>
    </div>
  </Teleport>
</template>

<script>
import { useAuthStore } from '@/stores/auth'
import { fetchWrapper } from '@/wrappers/api/fetchWrapper'
import SignupPage from './SignupPage.vue';

export default {
  name: "LoginPage",
  emits: ['close'],
  components: { SignupPage },
  setup() {
    const authStore = useAuthStore();
    return { authStore };
  },
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      isLoading: false,
      showSignupContent: false,
    }
  },
  methods: {
    async handleLogin() {
      const authStore = useAuthStore();
      this.isLoading = true;
      this.errorMessage = '';

      try {
        const data = await fetchWrapper.post('/login', {
          email: this.email,
          password: this.password
        });

        const userData = data.response;
        authStore.setUser(userData);

        // Delay closing the login modal by 2 seconds
        setTimeout(() => {
          this.$emit('close');
        }, 2000);
        // this.$router.push('/dashboard');

      } catch (err) {
        this.errorMessage = "Niepoprawne dane logowania!";
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.login-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  backdrop-filter: blur(5px);
}

.login-modal-content {
  width: 100%;
  max-width: 400px;
  animation: modal-appear 0.3s ease-out;
}

@keyframes modal-appear {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

.card {
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}
.form-control:focus {
  background-color: #212529;
  color: white;
  border-color: #f0c040;
  box-shadow: 0 0 0 0.25rem rgba(240, 192, 64, 0.25);
}
.btn-warning {
  background-color: #f0c040;
  border-color: #f0c040;
}
.btn-warning:hover {
  background-color: #ffd966;
  border-color: #ffd966;
}
</style>